module.exports = __webpack_public_path__ + "img/Perks-Gift-50.865416ca.png";